import React from 'react'
import PricingForm from '../../components/PricingForm/PricingForm'

const Sidebar = (props) => {
    return (
        <div className="col col-lg-4 col-12 course-sitebar">
            <div className="blog-sidebar">
                <PricingForm />
            </div>
        </div>
    )
}

export default Sidebar;